module.exports = __webpack_public_path__ + "img/roll_d_a.b42d7234.png";